export function normalize(url: string | URL) {
  return new URL(url || "about:blank");
}
